'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var LoaderContent = require('../../01.atoms/LoaderContent/LoaderContent.js');
var Form = require('../../02.molecules/Form/Form.js');
var Input = require('../../02.molecules/Input/Input.js');
var Select$1 = require('../../02.molecules/Select/Select.js');
var dynamic = require('../../../utils/dynamic/dynamic.js');
var routeToLink = require('../../../utils/routeToLink.js');
require('./_index.scss.js');

var SearchVehicleType = dynamic(function () {
  return new Promise(function (resolve) { resolve({ 'default': require('../SearchVehicleType/SearchVehicleType.js') }); });
}, {
  loading: function loading() {
    return /*#__PURE__*/React__default.createElement(LoaderContent, {
      contentPlaceholder: true,
      delay: 0
    });
  }
});
var CLASSNAME = 'varta-teaser-car-battery-finder',
    cnWrapperOuter = "".concat(CLASSNAME, "__wrapper-outer"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnSidebar = "".concat(CLASSNAME, "__sidebar"),
    cnSidebarSelect = "".concat(cnSidebar, "__select"),
    cnItems = "".concat(CLASSNAME, "__items"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnItemActive = "".concat(cnItem, "--active"),
    cnLink = "".concat(CLASSNAME, "__link"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col"),
    cnButtons = "".concat(CLASSNAME, "__buttons");
var KBA_LOCALE = 'de-DE';
var NUMBER_PLATE_LOCALE = ['en-GB', 'ie-IE', 'fr-FR', 'sv-SE'];
var DUAL_NUMBER_PLATE_SEARCH = ['en-GB', 'ie-IE'];
/**
 * 
 */

var TeaserCarBatteryFinder = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(TeaserCarBatteryFinder, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(TeaserCarBatteryFinder);

  function TeaserCarBatteryFinder() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, TeaserCarBatteryFinder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      activeItem: _this.items[0]
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onChange", function (value) {
      _this.setState({
        activeItem: value,
        tecdocNumber: null,
        kb1: null,
        kb2: null,
        batteryNumber: null,
        numberPlate1: null,
        numberPlate2: null
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onSearch", function () {
      var _this$props = _this.props,
          locale = _this$props.locale,
          resultLinkPattern = _this$props.resultLinkPattern,
          track = _this$props.track;
      var activeItem = _this.state.activeItem;
      track(activeItem.value);

      var query = _this.getSearchParams();

      var language = null;
      var link = null;

      if (activeItem.value === 'number-plate') {
        language = query.param2;
        query = {
          param1: query.param1
        };
      }
      /** Pattern of result URL e.g. '/:locale/search/:type' */


      if (language) {
        link = routeToLink(resultLinkPattern, _rollupPluginBabelHelpers.objectSpread2({
          locale: locale,
          searchType: activeItem.value
        }, query), {
          language: language
        });
      } else {
        link = routeToLink(resultLinkPattern, _rollupPluginBabelHelpers.objectSpread2({
          locale: locale,
          searchType: activeItem.value
        }, query));
      }

      link = "".concat(link, "#result");
      window.open(link, '_self');
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(TeaserCarBatteryFinder, [{
    key: "items",
    get: function get() {
      var _this$props2 = this.props,
          i18n = _this$props2.i18n,
          locale = _this$props2.locale;
      var items = [].concat(_rollupPluginBabelHelpers.toConsumableArray(i18n.kbaNumber && locale === KBA_LOCALE ? [{
        title: i18n.kbaNumber,
        value: 'kba-number'
      }] : []), [{
        title: i18n.vehicleType,
        value: 'vehicle-type'
      }, {
        title: i18n.tecDocNumber,
        value: 'tecdoc-number'
      }, {
        title: i18n.batteryCode,
        value: 'battery-number'
      }]);

      if (i18n.numberPlate && NUMBER_PLATE_LOCALE.indexOf(locale) !== -1) {
        var numberPlateItem = {
          title: i18n.numberPlate,
          value: 'number-plate'
        };

        if (locale === 'sv-SE') {
          items.unshift(numberPlateItem);
        } else {
          items.push(numberPlateItem);
        }
      }

      return items;
    }
  }, {
    key: "getSearchParams",
    value: function getSearchParams() {
      var _this$props$batteryFi = this.props.batteryFinder,
          manufacturerId = _this$props$batteryFi.manufacturerId,
          modelId = _this$props$batteryFi.modelId,
          year = _this$props$batteryFi.year,
          engineId = _this$props$batteryFi.engineId;
      var _this$state = this.state,
          kb1 = _this$state.kb1,
          kb2 = _this$state.kb2,
          tecdocNumber = _this$state.tecdocNumber,
          batteryNumber = _this$state.batteryNumber,
          numberPlate1 = _this$state.numberPlate1,
          numberPlate2 = _this$state.numberPlate2,
          activeItem = _this$state.activeItem;

      switch (activeItem.value) {
        case 'vehicle-type':
          return {
            param1: year,
            param2: manufacturerId,
            modelId: modelId,
            engineId: engineId
          };

        case 'battery-number':
          return {
            param1: batteryNumber
          };

        case 'tecdoc-number':
          return {
            param1: tecdocNumber
          };

        case 'kba-number':
          return {
            param1: kb1,
            param2: kb2
          };

        case 'number-plate':
          return {
            param1: (numberPlate1 === null || numberPlate1 === void 0 ? void 0 : numberPlate1.value) || (numberPlate2 === null || numberPlate2 === void 0 ? void 0 : numberPlate2.value),
            param2: (numberPlate1 === null || numberPlate1 === void 0 ? void 0 : numberPlate1.lang) || (numberPlate2 === null || numberPlate2 === void 0 ? void 0 : numberPlate2.lang)
          };
      }

      return {};
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this2 = this;

      var _this$props3 = this.props,
          locale = _this$props3.locale,
          token = _this$props3.token,
          _this$props3$batteryF = _this$props3.batteryFinder,
          year = _this$props3$batteryF.year,
          manufacturerId = _this$props3$batteryF.manufacturerId,
          modelId = _this$props3$batteryF.modelId,
          engineId = _this$props3$batteryF.engineId,
          _this$props3$batteryF2 = _this$props3$batteryF.search;
      _this$props3$batteryF2 = _this$props3$batteryF2 === void 0 ? {} : _this$props3$batteryF2;
      var isLoading = _this$props3$batteryF2.isLoading,
          years = _this$props3$batteryF2.TYPE_YEAR,
          manufacturer = _this$props3$batteryF2.TYPE_MANUFACTURER,
          modelline = _this$props3$batteryF2.TYPE_MODELLINE,
          modeltype = _this$props3$batteryF2.TYPE_MODELTYPE,
          onUpdateEngineId = _this$props3.onUpdateEngineId,
          onFetchSearchStart = _this$props3.onFetchSearchStart,
          vehicleTypeId = _this$props3.vehicleTypeId,
          i18n = _this$props3.i18n;
      var activeItem = this.state.activeItem;

      switch (activeItem.value) {
        case 'kba-number':
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: cnRow
          }, /*#__PURE__*/React__default.createElement("div", {
            className: cnCol
          }, /*#__PURE__*/React__default.createElement(Input, {
            light: true,
            title: i18n.kbaNumber1,
            placeholder: i18n.placeholderInput,
            onChange: function onChange(value) {
              return _this2.setState({
                kb1: value
              });
            }
          })), /*#__PURE__*/React__default.createElement("div", {
            className: cnCol
          }, /*#__PURE__*/React__default.createElement(Input, {
            light: true,
            title: i18n.kbaNumber2,
            placeholder: i18n.placeholderInput,
            onChange: function onChange(value) {
              return _this2.setState({
                kb2: value
              });
            }
          }))));

        case 'tecdoc-number':
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input, {
            light: true,
            title: i18n.tecDocNumber,
            placeholder: i18n.placeholderInput,
            onChange: function onChange(value) {
              return _this2.setState({
                tecdocNumber: value
              });
            }
          })));

        case 'battery-number':
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input, {
            light: true,
            title: i18n.batteryCode,
            placeholder: i18n.placeholderInput,
            minLength: 2,
            onChange: function onChange(value) {
              return _this2.setState({
                batteryNumber: value
              });
            }
          })));

        case 'number-plate':
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input, {
            light: true,
            title: i18n.numberPlate1,
            placeholder: i18n.placeholderInput,
            minLength: 5,
            onChange: function onChange(value) {
              return _this2.setState({
                numberPlate1: {
                  value: value,
                  lang: locale
                }
              });
            }
          }), DUAL_NUMBER_PLATE_SEARCH.indexOf(locale) !== -1 && /*#__PURE__*/React__default.createElement(Input, {
            light: true,
            title: i18n.numberPlate2,
            placeholder: i18n.placeholderInput,
            minLength: 5,
            onChange: function onChange(value) {
              return _this2.setState({
                numberPlate2: {
                  value: value,
                  lang: DUAL_NUMBER_PLATE_SEARCH[1]
                }
              });
            }
          })));

        default:
          return /*#__PURE__*/React__default.createElement(SearchVehicleType, {
            isLoading: isLoading,
            year: year,
            vehicleTypeId: vehicleTypeId,
            locale: locale,
            token: token,
            manufacturerId: manufacturerId,
            modelId: modelId,
            engineId: engineId,
            onUpdateEngineId: onUpdateEngineId,
            onFetchSearchStart: onFetchSearchStart,
            years: years,
            manufacturer: manufacturer,
            modelline: modelline,
            modeltype: modeltype,
            twoColumns: true,
            light: true,
            i18n: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, i18n), {}, {
              placeholder: i18n.placeholderSelect
            })
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          breakpoint = _this$props4.breakpoint,
          background = _this$props4.background,
          engineId = _this$props4.batteryFinder.engineId,
          i18n = _this$props4.i18n;
      var _this$state2 = this.state,
          activeItem = _this$state2.activeItem,
          kb1 = _this$state2.kb1,
          kb2 = _this$state2.kb2,
          numberPlate1 = _this$state2.numberPlate1,
          numberPlate2 = _this$state2.numberPlate2,
          tecdocNumber = _this$state2.tecdocNumber,
          batteryNumber = _this$state2.batteryNumber;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(React.Suspense, {
        fallback: /*#__PURE__*/React__default.createElement(LoaderContent, null)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className)
      }, /*#__PURE__*/React__default.createElement(Form, {
        className: cnWrapperOuter,
        style: {
          backgroundImage: "url(".concat(background, ")")
        },
        onSubmitSuccess: this.onSearch
      }, /*#__PURE__*/React__default.createElement("h1", {
        className: cnTitle
      }, i18n.title), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, breakpoint === 'xs' || breakpoint === 'sm' ? /*#__PURE__*/React__default.createElement("aside", {
        className: cnSidebar
      }, /*#__PURE__*/React__default.createElement(Select$1, {
        light: true,
        title: i18n.searchBy,
        options: this.items,
        defaultValue: this.items[0].value,
        onChange: this.onChange,
        className: cnSidebarSelect
      })) : /*#__PURE__*/React__default.createElement("aside", {
        className: cnSidebar
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnItems
      }, this.items.map(function (item) {
        return /*#__PURE__*/React__default.createElement("a", {
          href: "#",
          key: item.value,
          className: classNames(cnItem, _rollupPluginBabelHelpers.defineProperty({}, cnItemActive, activeItem.value === item.value)),
          onClick: function onClick(e) {
            e.preventDefault();

            _this3.onChange(item);
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: cnLink
        }, item.title));
      }))), /*#__PURE__*/React__default.createElement("section", {
        className: cnContent
      }, this.renderForm())), /*#__PURE__*/React__default.createElement("footer", {
        className: cnButtons
      }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
        title: i18n.search,
        type: "light",
        wide: true,
        disabled: !(engineId || kb1 && kb2 || tecdocNumber || batteryNumber && batteryNumber.length >= 2 || numberPlate1 || numberPlate2),
        submit: true
      }))))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var i18n = props.i18n,
          locale = props.locale;
      var activeItem = state.activeItem;

      if (!(i18n.kbaNumber && locale === KBA_LOCALE) && activeItem.value === 'kba-number') {
        return {
          activeItem: {
            title: i18n.vehicleType,
            value: 'vehicle-type'
          }
        };
      }

      return null;
    }
  }]);

  return TeaserCarBatteryFinder;
}(React__default.Component);
TeaserCarBatteryFinder.propTypes = {
  /** */
  background: PropTypes.string,

  /** */
  batteryFinder: PropTypes.shape(),

  /** */
  breakpoint: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** */
  locale: PropTypes.string,

  /** */
  token: PropTypes.string,

  /** */
  vehicleTypeId: PropTypes.string,

  /** */
  onUpdateEngineId: PropTypes.func,

  /** */
  onFetchSearchStart: PropTypes.func,

  /** Pattern of result URL e.g. '/:locale/search/:type' */
  resultLinkPattern: PropTypes.string.isRequired,

  /** Translation object */
  i18n: PropTypes.shape({
    search: PropTypes.string.isRequired,
    kbaNumber: PropTypes.string,
    numberPlate: PropTypes.string,
    placeholderInput: PropTypes.string,
    placeholderSelect: PropTypes.string,
    kbaNumber1: PropTypes.string,
    kbaNumber2: PropTypes.string,
    numberPlate1: PropTypes.string,
    numberPlate2: PropTypes.string,
    vehicleType: PropTypes.string.isRequired,
    tecDocNumber: PropTypes.string.isRequired,
    batteryCode: PropTypes.string.isRequired,
    searchBy: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }),

  /** */
  track: PropTypes.func
};
TeaserCarBatteryFinder.defaultProps = {
  batteryFinder: {},
  i18n: {},
  track: function track() {
    return void 0;
  }
};

module.exports = TeaserCarBatteryFinder;
